import React from "react";

import { SchoolWithExamRegistration } from "../../types/types";

interface FinancialTableProps {
  registrationData: SchoolWithExamRegistration | null;
  selectedExamTypeIds: number[];
}

const FinancialTable: React.FC<FinancialTableProps> = ({
  registrationData,
  selectedExamTypeIds,
}) => {
  if (!registrationData || selectedExamTypeIds.length === 0) {
    return null;
  }

  const financialData = registrationData?.exam_registration?.financial_data;
  if (!financialData) {
    return null;
  }

  return (
    <table className="gceo-financial-table">
      <thead>
        <tr className="text-nowrap" style={{ lineHeight: "6px" }}>
          <th className="gceo-financial-header" rowSpan={2}>
            FINANCIAL TRANSACTIONS
            <br />
          </th>
          {financialData.exam_types.map((examType) => (
            <th className="gceo-financial-header" rowSpan={2} key={examType.id}>
              {examType.name}
            </th>
          ))}
          <th className="gceo-financial-header" rowSpan={2}>
            TOTAL
          </th>
          <th className="gceo-financial-header dark" rowSpan={2}>
            For Official Use Only
          </th>
        </tr>
      </thead>
      <tbody>
        <tr className="text-nowrap" style={{ lineHeight: "6px" }}>
          <td className="gceo-financial-cell text-start">RATE PER CANDIDATE</td>
          {financialData.exam_types.map((examType) => (
            <td className="gceo-financial-cell" key={examType.id}>
              {examType.registration_fee.toLocaleString()} FRS
            </td>
          ))}
          <td className="gceo-financial-cell">-----</td>
          <td className="gceo-financial-cell text-wrap" rowSpan={5}>
            Read instructions at end of form before filling.
          </td>
        </tr>
        <tr className="text-nowrap" style={{ lineHeight: "6px" }}>
          <td className="gceo-financial-cell">No. of Candidates</td>
          {financialData.exam_types.map((examType) => (
            <td className="gceo-financial-cell" key={examType.id}>
              {examType.candidate_count}
            </td>
          ))}
          <td className="gceo-financial-cell">
            {financialData.total_candidates}
          </td>
        </tr>
        <tr className="text-nowrap" style={{ lineHeight: "6px" }}>
          <td className="gceo-financial-cell">Amount due</td>
          {financialData.exam_types.map((examType) => (
            <td className="gceo-financial-cell" key={examType.id}>
              {examType.amount_due.toLocaleString()} FRS
            </td>
          ))}
          <td className="gceo-financial-cell">
            {financialData.total_amount_due.toLocaleString()} FRS
          </td>
        </tr>
        <tr className="text-nowrap" style={{ lineHeight: "6px" }}>
          <td className="gceo-financial-cell">
            {financialData.discount_percentage
              ? `${(financialData.discount_percentage * 100).toFixed(0)}% retained by school`
              : "16% retained by school"}
          </td>
          {financialData.exam_types.map((examType) => (
            <td className="gceo-financial-cell" key={examType.id}>
              {examType.school_retained.toLocaleString()} FRS
            </td>
          ))}
          <td className="gceo-financial-cell">
            {financialData.school_retained_amount.toLocaleString()} FRS
          </td>
        </tr>
        <tr className="text-nowrap" style={{ lineHeight: "6px" }}>
          <td className="gceo-financial-cell">
            Balance ({financialData.discount_percentage
              ? `${(100 - financialData.discount_percentage * 100).toFixed(0)}%`
              : "84%"}) to the TRU
          </td>
          {financialData.exam_types.map((examType) => (
            <td className="gceo-financial-cell" key={examType.id}>
              {examType.tru_balance.toLocaleString()} FRS
            </td>
          ))}
          <td className="gceo-financial-cell">
            {financialData.tru_balance.toLocaleString()} FRS
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default FinancialTable;
